<div class="sub-menu collapsed" id="sub-menu" (mouseover)="expandMenu(submenu)" (mouseout)="collapseMenu(submenu)"
  #submenu>
  <div class="sidebar-header">
    <div class="sidebar-header-badge sidebar-title">
      <i class="icon fas fa-cog" *ngIf="type === 'ENDPOINT'"></i>
      <i class="icon fas fa-tasks" *ngIf="type === 'TESTCASE'"></i>
      <i class="icon fas fa-tasks" *ngIf="type === 'NEW_TESTCASE'"></i>
      <i class="icon fas fa-layer-group" *ngIf="type === 'TESTSUITE'"></i>
      <i class="icon fas fa-sitemap" *ngIf="type === 'MASTERSUITE'"></i>
      <span class="name">{{ type === 'NEW_TESTCASE' ? 'TESTCASE' : type }}</span>
    </div>
  </div>

  <ul class="sidebar-menu">
    <li *ngFor="let item of setSideMenu" [appPermission]="item.permission">
      <a [routerLink]="item.link" id="" title="{{ item.title }}" [queryParams]="item.queryParams"
        routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <i class="icon" [ngClass]="item.icon" *ngIf="item.icon"></i>
        <span class="name item-label">{{ item.name }}</span>
      </a>
    </li>
  </ul>

  <div class="sidebar-footer">
    <div class="sidebar-badge">
      <i class="fas fa-question-circle"></i>
      <span class="name"><a href={{wikiLink}} target="_blank" style="color: inherit;">Need help ?</a></span>
    </div>
  </div>
</div>